import React, { useEffect } from 'react'
import { inputValidationCheck } from '../../../validators/inputValidators/inputValidators'
import { useFormValidation } from '../../../hooks/useFormValidation'
import { getLabel } from '../../../utils/getLabel'
import { buildControlsExt, integerInput } from '../../inputs/controls'
import { setDefaultValue } from '../utils/setDefault'
import {
    modifyActionParameter,
    setActionInvalid,
    setActionValid,
} from '../../../store/actions/actionsActions'
import { numberInputErrors } from '../../../utils/validationErrors/numberInputErrors'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { isEmpty } from '../utils/isEmpty'
import { useInitialEffect } from '../../../hooks/useInitialEffect'
import { useEffectAfterMount } from '../../../hooks/useEffectAfterMount'
import { IDurationProps } from '../../models/Duration/types'
import { useDebouncedValue } from '../../../hooks/useDebouncedValue'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { selectInvalidActionByErrorKey } from '../../../store/selectors/actionsSelectors/invalidActionsSelectors'
import { PATH_JOINER } from '../../models/utils/getConfigBitPath'

export const DurationACTN = (props: IDurationProps) => {
    const { data = {}, dataSchema, name, wrapper, dataPath } = props
    const dispatch = useAppDispatch()

    const path = [...(dataPath.split(PATH_JOINER)), name]

    const {
        is_required: isRequired,
        name: inputLabel,
        type,
        description: tooltipText,
        format,
        default: defaultValue,
    } = dataSchema

    const validationCheck = inputValidationCheck(type, dataSchema)
    const [
        inputState,
        setInputState,
        touched,
        setTouched,
        validationResult,
        isInputStateValid,
    ] = useFormValidation(data, { [name]: validationCheck })

    const debouncedInputState = useDebouncedValue(inputState, 500)
    const isActionFieldInvalid = !!useAppSelector(
        selectInvalidActionByErrorKey(path)
    )
    const isDataEmpty = isEmpty(data, name)
    const errMsg = numberInputErrors(inputState?.[name], dataSchema)
    const label = getLabel(name, inputLabel)
    const className = !wrapper ? 'w-100' : ''

    const controlDescriptors = [
        integerInput({
            name,
            validationType: 'integer',
            tooltipText,
            placeholder: defaultValue || `${format}...`,
            label,
            className,
            isColumn: true,
            errMsg,
            isRequired,
        }),
    ]

    const DurationInput = buildControlsExt(
        controlDescriptors,
        inputState,
        setInputState,
        touched,
        setTouched,
        validationResult
    )

    useInitialEffect(() => {
        if (isDataEmpty) {
            if (defaultValue) {
                setDefaultValue(setInputState, name, defaultValue)
            } else {
                setInputState((prev: any) => ({ ...prev, [name]: null }))
            }
        }
    })

    useEffect(() => {
        dispatch(
            modifyActionParameter({
                path,
                data: inputState,
            })
        )
    }, [debouncedInputState, dispatch])

    useEffectAfterMount(() => {
        const isCurrentValueValid = isInputStateValid()
        if (isActionFieldInvalid === isCurrentValueValid) {
            if (isCurrentValueValid) {
                dispatch(setActionValid({ path }))
            } else {
                dispatch(setActionInvalid({ path }))
            }
        }
    }, [debouncedInputState, dispatch])

    return <div className={`${!wrapper ? 'w-100' : ''}`}>{DurationInput}</div>
}
